import {vaultSvg as Icon__small__vaultSvg} from '../Icon__small/Icon__small--vault.js';

export var vault = {
  name: 'vault',
  category: 'icon',
  colorable: true,
  svg: Icon__small__vaultSvg,
};
